jQuery(document).ready(function($) {

    $( '.wp-block-wpopus-header-search svg' ).on( 'click', function() {
        $( '.wpopus-search-form' ).addClass( 'search-open' );
        $('.wpopus-search-form input.search-field').focus();
    } );

    var searchClose = true;
    $('.wpopus-search-form form').hover(function(){ 
        searchClose=false; 
    }, function(){ 
        searchClose=true; 
    });

    $('.wpopus-search-form').on('click', function() { 
        if ( searchClose ) {
            $(this).toggleClass('search-open');
        }
    });

});
